import type { LightboxImage } from './types';
import { getLightboxSrcData } from './imageLoader';

export function isElementHidden(el: HTMLElement): boolean {
    if (el.closest('.is-hidden')) {
        return true;
    }

    return el.offsetParent === null && getComputedStyle(el).position !== 'fixed';
}

export function collectGroupImages(groupName: string | null): LightboxImage[] {
    const images: LightboxImage[] = [];
    const selector = groupName
        ? `[data-lightbox][data-lightbox-group="${groupName}"]`
        : '[data-lightbox]:not([data-lightbox-group])';

    document.querySelectorAll<HTMLElement>(selector).forEach((el) => {
        if (isElementHidden(el)) {
            return;
        }

        const srcData = getLightboxSrcData(el);
        const alt = el.getAttribute('data-lightbox-caption') || (el as HTMLImageElement).alt || '';

        if (srcData) {
            images.push({
                srcData: srcData,
                alt: alt,
                element: el
            });
        }
    });

    return images;
}
